import React from "react";
import { Box, Container, Grid, Typography, Link, IconButton, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import PaymentIcon from "@mui/icons-material/Payment";

const Footer = () => {
  const navigate = useNavigate();

  const features = [
    { icon: <LocalShippingIcon />, title: "Free Shipping", desc: "On orders above ₹999" },
    { icon: <VerifiedUserIcon />, title: "100% Premium Quality", desc: "Certified & trusted jewellery" },
    { icon: <SupportAgentIcon />, title: "24/7 Support", desc: "Dedicated customer assistance" },
    { icon: <PaymentIcon />, title: "Secure Payment", desc: "Safe & multiple payment options" },
  ];

  return (
    <Box component="footer" sx={{ bgcolor: "#000", color: "#fff", mt: 6 }}>
      
      {/* Features Bar */}
      <Box sx={{ bgcolor: "#111", py: 3 }}>
        <Container maxWidth="lg">
          <Grid container spacing={2} justifyContent="center">
            {features.map((feature, index) => (
              <Grid item xs={6} sm={3} key={index}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, justifyContent: "center" }}>
                  <Box sx={{ color: "#d4af37" }}>{feature.icon}</Box>
                  <Box>
                    <Typography variant="body2" fontWeight="bold">
                      {feature.title}
                    </Typography>
                    <Typography variant="caption" sx={{ color: "#bbb" }}>
                      {feature.desc}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ py: 5 }}>
        <Grid container spacing={4}>

          {/* Brand Section */}
          <Grid item xs={12} md={4}>
            <Typography variant="h5" fontWeight="bold" sx={{ color: "#d4af37", mb: 2 }}>
              RoopShingar Jewellery
            </Typography>

            <Typography variant="body2" sx={{ color: "#bbb", mb: 2, lineHeight: 1.8 }}>
              We celebrate your beauty with jewellery designed to enhance your elegance 
              and express your individuality.
            </Typography>

            <Box sx={{ display: "flex", gap: 1 }}>
              {[FacebookIcon, InstagramIcon, TwitterIcon, YouTubeIcon].map((Icon, i) => (
                <IconButton
                  key={i}
                  sx={{ color: "#fff", "&:hover": { color: "#d4af37" } }}
                >
                  <Icon />
                </IconButton>
              ))}
            </Box>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={6} sm={3} md={2}>
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
              Quick Links
            </Typography>

            {[
              { label: "Home", path: "/" },
              { label: "Shop All", path: "/filter/All" },
              { label: "About Us", path: "/about" },
              { label: "Contact", path: "/contact" },
            ].map((item, i) => (
              <Link
                key={i}
                component="button"
                onClick={() => navigate(item.path)}
                sx={{
                  display: "block",
                  color: "#bbb",
                  textDecoration: "none",
                  mb: 1,
                  textAlign: "left",
                  "&:hover": { color: "#d4af37" },
                }}
              >
                {item.label}
              </Link>
            ))}
          </Grid>

          {/* Customer Service */}
          <Grid item xs={6} sm={3} md={3}>
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
              Customer Service
            </Typography>

            {[
              { label: "Track Order", path: "/orders" },
              { label: "FAQ", path: "/faq" },
              { label: "Shipping Policy", path: "/shipping" },
              { label: "Returns & Refunds", path: "/returns" },
            ].map((item, i) => (
              <Link
                key={i}
                component="button"
                onClick={() => navigate(item.path)}
                sx={{
                  display: "block",
                  color: "#bbb",
                  textDecoration: "none",
                  mb: 1,
                  textAlign: "left",
                  "&:hover": { color: "#d4af37" },
                }}
              >
                {item.label}
              </Link>
            ))}
          </Grid>

          {/* Contact Info */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
              Contact Us
            </Typography>

            <Typography variant="body2" sx={{ color: "#bbb", mb: 1 }}>
              Shop No. 7, Hera Panna Complex,  
              Burhanpur
            </Typography>

            <Typography variant="body2" sx={{ color: "#bbb", mb: 1 }}>
              Email: support@RoopShingar.com
            </Typography>

            <Typography variant="body2" sx={{ color: "#bbb" }}>
              Mon - Sat: 9AM - 7PM
            </Typography>
          </Grid>
        </Grid>
      </Container>

      <Divider sx={{ borderColor: "#222" }} />

      {/* Copyright */}
      <Box sx={{ py: 2, textAlign: "center" }}>
        <Typography variant="body2" sx={{ color: "#777" }}>
          © {new Date().getFullYear()} RoopShingar Jewellery. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
